module.exports = __webpack_public_path__ + "img/bg.905bd900.jpg";